import { Icon, Stack, Typography } from "components";
import styles from "./Section.module.css";

interface SectionProps extends React.PropsWithChildren {
  style?: React.CSSProperties;
  header?: {
    title: string;
    onBack?(): void;
  };
}

const Section: React.FC<SectionProps> = ({ header, style, children }) => (
  <section className={styles.container} style={style}>
    {header && (
      <Stack component="header" className={styles.header} placeItems="center">
        {header.onBack && <Icon name="arrow_back" onClick={header.onBack} />}
        <Typography component="h1" weight={500} size={1}>
          {header.title}
        </Typography>
      </Stack>
    )}
    <div className={styles.body}>{children}</div>
  </section>
);

export { Section };
